import { cn } from '@/lib/utils';

/**
 * "Mohair Notes" with the tilted terracotta "o" — the brand board's mark, "a
 * note slipping into its folder".
 *
 * Set as live text in the display face rather than as an SVG so it stays
 * selectable and scales with the surrounding type. The tilt is applied to an
 * `inline-block` because `transform` has no effect on a non-replaced inline
 * element.
 *
 * The `o` is `--brand-terracotta` at full strength rather than `--primary`:
 * this is a logotype, which WCAG 1.4.3 exempts, and the letter is legible from
 * its shape and its position in a word the reader already knows.
 */
export function Wordmark({ className }: { className?: string }) {
    return (
        <span
            className={cn(
                'font-display text-[clamp(21px,5vw,26px)] leading-none tracking-[0] text-foreground',
                className,
            )}
        >
            Mohair N
            <span className="inline-block rotate-[12deg] text-brand-terracotta">
                o
            </span>
            tes
        </span>
    );
}
